import styles from './Data.module.scss';

import { CSSProperties, type ReactNode } from 'react';

interface Props {
  align?: 'start' | 'center' | 'end';
  children: ReactNode;
  contained?: boolean;
  end?: ReactNode;
  icon?: ReactNode;
  image?: string;
  inline?: boolean;
  label?: ReactNode;
  style?: CSSProperties;
}

export function Data({
  align = 'start',
  children,
  contained,
  end,
  icon,
  label,
  inline,
  style,
}: Props) {
  const className = [
    styles['data'],
    contained && styles['data-contained'],
    inline && styles['data-inline'],
    styles[`data-${inline ? 'inline-' : ''}align-${align}`],
  ]
    .filter(Boolean)
    .join(' ');
  const labelClassName = [styles['data-label']].filter(Boolean).join(' ');
  const contentClassName = [styles['data-content']].filter(Boolean).join(' ');

  return (
    <div className={className} style={style}>
      {label && <span className={labelClassName}>{label}</span>}
      <div className={styles['data-icon-content']}>
        {icon}
        <div className={contentClassName}>{children}</div>
        {end && <div>{end}</div>}
      </div>
    </div>
  );
}
